import { Controller } from "@hotwired/stimulus"
import { debounce } from "../helpers/timing_helpers"
import { filterMatches } from "../helpers/text_helpers"

export default class extends Controller {
  static targets = ["searchInput", "contactItem", "relationshipChip", "emptyState", "list"]
  static values = { selectedRelationship: String }

  initialize() {
    this.search = debounce(this.search.bind(this), 100)
  }

  search() {
    this.applyFilters()
  }

  filterByRelationship(event) {
    const relationship = event.currentTarget.dataset.relationship || ""
    this.selectedRelationshipValue = relationship

    this.relationshipChipTargets.forEach(chip => {
      chip.classList.toggle("is-active", chip.dataset.relationship === relationship)
    })

    this.applyFilters()
  }

  closeForm() {
    const frame = document.getElementById("contact_form")
    if (frame) frame.innerHTML = ""
  }

  applyFilters() {
    const searchValue = this.hasSearchInputTarget ? this.searchInputTarget.value.trim() : ""
    const relationshipValue = this.selectedRelationshipValue || ""
    let visibleCount = 0

    this.contactItemTargets.forEach(item => {
      const name = item.dataset.contactName || ""
      const relationships = (item.dataset.contactRelationship || "").split(/\s+/).filter(Boolean)

      const matchesSearch = !searchValue || filterMatches(name, searchValue)
      const matchesRelationship = !relationshipValue || relationships.includes(relationshipValue)

      const visible = matchesSearch && matchesRelationship
      const row = item.closest("turbo-frame") || item
      row.toggleAttribute("hidden", !visible)
      if (visible) visibleCount++
    })

    if (this.hasEmptyStateTarget) {
      const hasFilter = searchValue.length > 0 || relationshipValue.length > 0
      this.emptyStateTarget.toggleAttribute("hidden", !(hasFilter && visibleCount === 0))
    }
  }
}
